import { TABLE_COLUMN_WIDTH } from '../../../components/ModelCompareV4/constants.mjs';
import { enterpriseCampus24PoE } from './products/enterpriseCampus24PoE.mjs';
import { enterpriseCampus48PoE } from './products/enterpriseCampus48PoE.mjs';
import { enterpriseCampusAggregation } from './products/enterpriseCampusAggregation.mjs';
import './properties/index.mjs';
import { generalRedundancy } from './properties/generalRedundancy.mjs';
import { dimensions } from './properties/dimensions.mjs';
import { portCount } from './properties/portCount.mjs';
import { downlinkSpeed } from './properties/downlinkSpeed.mjs';
import { uplinkSpeed } from './properties/uplinkSpeed.mjs';
import { poeOutput } from './properties/poeOutput.mjs';
import { poeAvailability } from './properties/poeAvailability.mjs';
import { etherlighting } from './properties/etherlighting.mjs';
import { proAvSupport } from './properties/proAvSupport.mjs';
import { mounting } from './properties/mounting.mjs';
"use strict";
const SwitchingEnterprise = {
  properties: [dimensions, portCount, downlinkSpeed, uplinkSpeed, poeOutput, poeAvailability, etherlighting, proAvSupport, mounting, generalRedundancy],
  products: [enterpriseCampusAggregation, enterpriseCampus48PoE, enterpriseCampus24PoE
  /** Still waiting on data */
  // enterpriseCampus48SPoE,
  // enterpriseCampus24SPoE,
  ],
  columnWidth: TABLE_COLUMN_WIDTH
};
export { SwitchingEnterprise };
//# sourceMappingURL=SwitchingEnterprise.mjs.map
